import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import DialogActions from '@material-ui/core/DialogActions';
import { withStyles } from '@material-ui/styles';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import PrimaryCta from 'base/components/PrimaryCta';
import SecondaryCta from 'base/components/SecondaryCta';

const styles = theme => ({
  paper: {
    maxHeight: 'none',
    maxWidth: 'none',
    height: '100%',
    width: '100%',
    margin: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    borderRadius: 0
  },
  root: {
    [theme.breakpoints.up('sm')]: {
      position: 'absolute !important'
    }
  }
});

const CartConfirmModal = ({
  isOpen,
  toggleIsOpen,
  handleConfirm,
  container,
  classes
}) => {
  const theme = useTheme();
  const isSmallUp = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <Dialog fullWidth classes={classes} container={container} open={isOpen}>
      <Box
        height="100%"
        display="flex"
        flexDirection="column"
        padding={2.5}
        justifyContent={isSmallUp ? 'flex-start' : 'center'}
      >
        <Typography
          variant="h4"
          style={{
            textAlign: 'center'
          }}
        >
          Are you sure you want to empty your cart?
        </Typography>

        <DialogActions>
          <Box mt={2}>
            <PrimaryCta
              fullWidth
              handleClick={handleConfirm}
              label="Yes, empty my cart"
            />
          </Box>

          <Box mt={2}>
            <SecondaryCta
              fullWidth
              label="Return to my cart"
              handleClick={toggleIsOpen}
            />
          </Box>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

CartConfirmModal.propTypes = {
  isOpen: PropTypes.bool,
  toggleIsOpen: PropTypes.func,
  handleConfirm: PropTypes.func,
  container: PropTypes.object,
  classes: PropTypes.shape({
    paper: PropTypes.string
  })
};

export default withStyles(styles)(CartConfirmModal);
